/**
 * 登陆注册
 * 用户信息相关模块
 * */
import request from "@/request";

// 账号登陆
export const onUserLogin = data => request.post('/api/user/login', data)

// 手机号登陆
export const onMobileLogin = data => request.post('/api/user/mobilelogin', data)

// 注册
export const onRegister = data => request.post('/api/user/register', data)

// 找回密码
export const onForget = data => request.post('/api/user/resetpwd', data)